<template>
  <div
    class="zk-row"
    :style="style"
    :class="[ justify !== 'start' ? 'is-justify-' + justify : '', align !== 'top' ? 'is-align-' + align : '', { 'zk-row--flex': type === 'flex' } ]">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZkRow',
    props: {
      gutter: Number,
      type: String,
      justify: {
        type: String,
        default: 'start'
      },
      align: {
        type: String,
        default: 'top'
      }
    },

    computed: {
      style() {
        var ret = {}
        if (this.gutter) {
          ret.marginLeft = `-${this.gutter / 2}px`
          ret.marginRight = ret.marginLeft
        }

        return ret
      }
    }
  }
</script>



// WEBPACK FOOTER //
// row.vue?5217f2b2